import { LineAPI } from '../../../api/bussched/LineAPI';

export class LinesCommand {
    list(edition, successCallback, errorCallback) {
        const apiResult = LineAPI.list(edition);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler as Linhas");
            }
        });
    }
}
